import createTrack from './TrackMouse';
export default function create(options) {
  const {
    distance = {
      value: 80,
      type: 'px'
    }
  } = options.namedEffect;
  const {
    transitionEasing = 'elastic'
  } = options;
  return createTrack({
    ...options,
    transitionEasing,
    namedEffect: {
      ...options.namedEffect,
      distance
    }
  });
}
//# sourceMappingURL=BounceMouse.js.map